export class TimerService {
    public static FORM_INSTANCE_LOAD = 'FormInstanceLoad';
    public static APPLY_FLEX_FIELD_OPTIONS = '  --> ApplyFlexFieldOptions';
    public static APPLY_CONDITIONAL_LOGIC = '   --> ApplyConditionalLogic';

    // PJH - 1/9/2026 - currently, output is only given for this operation
    public static FORMS_GRID_LOAD = "FomsGridLoad";

    private static OPERATIONS_FOR_WHICH_OUTPUT_WILL_BE_GIVEN: string[] = [
        //TimerService.FORMS_GRID_LOAD
    ];

    private times = {};


    private doOutput(op: string): boolean {
        return TimerService.OPERATIONS_FOR_WHICH_OUTPUT_WILL_BE_GIVEN.indexOf(op) > -1;
    }

    public startTimerFor(op: string, time: number = Date.now()) {
        if (this.doOutput(op))
            console.log(op + ': Starting Timer');
        this.times[op] = time;
        this.times[`PREVIOUS${op}`] = 0;
    }

    public outputFor(op: string, msg: string, outputTime: boolean = true, elapsed: number = Date.now()): void {
        const time = this.times[op];
        const previousTime = this.times[`PREVIOUS${op}`];
        if (!time) {
            this.times[op] = elapsed;
            this.times[`PREVIOUS${op}`] = 0;

            if (this.doOutput(op))
                console.log(`${op}: Starting Timer for ${msg}`);
        } else {
            const newTime = elapsed - time;

            let log = `${op}: ${msg}`;
            if (outputTime) {
                this.times[`PREVIOUS${op}`] = newTime;
                log += ` ${newTime / 1000}s (took ${(newTime - previousTime) / 1000}s)`;
            }

            if (this.doOutput(op))
                console.log(log);
        }
    }
}
